import { messages } from "../../../src/resources/strings";
import { useAppDispatch, useAppSelector } from "../../store/Store";
import { getLatestBanner, updateBanner } from "../banner";
import { isDateInRange } from "../../utilities/Validators";
import { getPolicyNumber } from "../../utilities/Helpers";
import { updateUserBanner } from "../../store/slices/UserSlice";
import { Logger } from "../../utilities/HelperFunctions";

const bannerHandler = () => {
  const { banner } = useAppSelector((state) => state.userReducer);
  const { policies } = useAppSelector((state) => state.policyReducer);
  const dispatch =useAppDispatch()

  const getBanner = async (policy: any) => {
    const bannerObject = await getLatestBanner(policy.policyNumber);
    const _isDateInRange = isDateInRange(
      bannerObject?.response?.startTime,
      bannerObject?.response?.stopTime
    );
  
    if (bannerObject.errorCode == messages.error.noError && _isDateInRange) {
      dispatch(updateUserBanner(bannerObject.response))
    } else {
      updateUserBanner(null);
    }
  };


  const fetchBanner = async () => {
    const selectedPolicyNumber = await getPolicyNumber();
    let policy = policies?.find(
      (item: any) => item.policyNumber === selectedPolicyNumber
    );
    if (policy != null) {
      getBanner(policy);
    }
  };

  const closeBanner = async () => {
    if (banner === null) return;
    const response = await updateBanner(banner?.id);
    if (response.errorCode == messages.error.noError) {
      updateUserBanner(null);
    } else {
      Logger("Banner updation failed");
    }
  };

  return {
    fetchBanner,
    closeBanner,
  };
};

export default bannerHandler;
